import React from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { View, Text, StyleSheet } from 'react-native';

import { themes } from '../../styles/themes';
import { GTAmericaCompressed } from '../../libs/constants';
import { useThemeState, useThemeDispatch } from '../../context/ThemeContext';
import { useDimensions } from '../../context/DimensionsContext';

interface Props {}

export const ThemePicker: React.FC<Props> = () => {
  const lgBreakpoint = 1180;
  const mdBreakpoint = 860;
  const smBreakpoint = 420;
  const { width } = useDimensions();
  const { theme } = useThemeState();
  const dispatch = useThemeDispatch();
  const client = useApolloClient();

  const styles = StyleSheet.create({
    themePicker: {
      fontFamily: GTAmericaCompressed,
      fontWeight: '400',
      fontSize: 21,
      letterSpacing: 2.1,
      textTransform: 'uppercase',
      marginHorizontal: width < mdBreakpoint ? 20 : 0,
    },
    container: {
      flexDirection: width < mdBreakpoint ? 'row' : 'column',
      justifyContent: width < mdBreakpoint ? 'space-between' : undefined,
    },
  });
  var themeOptions = Object.entries(themes).map(([key, themeValue]) => {
    return (
      <Text
        key={key}
        onPress={() => {
          dispatch(themeValue);
          client.writeData({ data: { theme: themeValue } });
        }}
        style={[
          styles.themePicker,
          {
            color: themeValue.foregroundColor,
            textDecorationLine:
              theme.id === themeValue.id ? 'underline' : 'none',
          },
        ]}
      >
        {themeValue.displayName}
      </Text>
    );
  });
  return <View style={styles.container}>{themeOptions}</View>;
};
